<template>
  <div class="product-container10">
    <app-navigation></app-navigation>
    <section id="company-story" role="region" aria-labelledby="company-story-title" class="company-story-section terms-section">
      <div class="terms-wrapper">
        <h2 id="company-story-title">{{ $t('terms.title') }}</h2><br>

        <p>{{ $t('terms.subtitle') }}</p>

        <h4>{{ $t('terms.article1.title') }}</h4>
        <p>{{ $t('terms.article1.sections[0]') }}</p>
        <p>{{ $t('terms.article1.sections[1]') }}</p><br>
        <h4>{{ $t('terms.article2.title') }}</h4>
        <p>{{ $t('terms.article2.sections[0]') }}</p>
        <p>{{ $t('terms.article2.sections[1]') }}</p>
        <p>{{ $t('terms.article2.sections[2]') }}</p>
        <p>{{ $t('terms.article2.sections[3]') }}</p><br>
        <h4>{{ $t('terms.article3.title') }}</h4>
        <p>{{ $t('terms.article3.sections[0]') }}</p>
        <p>{{ $t('terms.article3.sections[1]') }}</p>
        <p>{{ $t('terms.article3.sections[2]') }}</p><br>
        <h4>{{ $t('terms.article4.title') }}</h4>
        <p>{{ $t('terms.article4.sections[0]') }}</p>
        <p>{{ $t('terms.article4.sections[1]') }}</p>
        <p>{{ $t('terms.article4.sections[2]') }}</p>
        <p>{{ $t('terms.article4.sections[3]') }}</p>
        <p>{{ $t('terms.article4.sections[4]') }}</p>
        <p>{{ $t('terms.article4.sections[5]') }}</p>
        <p>{{ $t('terms.article4.sections[6]') }}</p><br>
        <h4>{{ $t('terms.article5.title') }}</h4>
        <p>{{ $t('terms.article5.sections[0]') }}</p>
        <p>{{ $t('terms.article5.sections[1]') }}</p><br>
        <h4>{{ $t('terms.article6.title') }}</h4>
        <p>{{ $t('terms.article6.sections[0]') }}</p>
        <p>{{ $t('terms.article6.sections[1]') }}</p>
        <p>{{ $t('terms.article6.sections[2]') }}</p>
        <p>{{ $t('terms.article6.sections[3]') }}</p>
        <p>{{ $t('terms.article6.sections[4]') }}</p>
        <p>{{ $t('terms.article6.sections[5]') }}</p>
        <p>{{ $t('terms.article6.sections[6]') }}</p><br>
        <p>{{ $t('terms.article6.garantie') }}</p>
        <ul class="terms-list">
          <li v-for="(option, index) in $tm('terms.article6.options', {}, { returnObjects: true })"
              :key="index">
            {{ option }}
          </li>
        </ul>
        <br>
        <p>{{ $t('terms.article6.defect') }}</p><br>
        <h4>{{ $t('terms.article7.title') }}</h4>
        <p>{{ $t('terms.article7.sections[0]') }}</p>
        <p>{{ $t('terms.article7.sections[1]') }}</p>
        <p>{{ $t('terms.article7.sections[2]') }}</p>
        <p>{{ $t('terms.article7.sections[3]') }}</p>
        <p>{{ $t('terms.article7.sections[4]') }}</p><br>
        <h4>{{ $t('terms.article8.title') }}</h4>
        <p>{{ $t('terms.article8.sections[0]') }}</p>
        <p>{{ $t('terms.article8.sections[1]') }}</p><br>
      </div>
    </section>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { useHead } from "@vueuse/head";
import AppNavigation from "../components/navigation.vue";
import AppFooter from "../components/footer.vue";

export default {
  name: "Terms",
  props: {},
  components: {AppNavigation, AppFooter},
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }    
  }
};
</script>

<style scoped>
.terms-section .terms-wrapper {
  grid-column: 1 / -1; /* span over beide kolommen */
}

.terms-section {
  flex-direction: column;
}

.terms-list {
  margin-left: 20px;
}
</style>